import React from "react";
import Masonry from "react-responsive-masonry"
import styled from "styled-components";
import { Main, Body, Box, ImageBox, LinkImageBox, TextBox } from './commonStyles';
import SafeTextToHTML from "../components/SafeTextToHTML";
import { sizeMapNumbers } from '../config'

const gridThreshold = 0.25; // Percentage diff to average where section should use a grid layout rather than masonry

function Text ({text, columnWidth}) {
    return (
        <>
            <TextBox><SafeTextToHTML text={text} /> </TextBox>
            <img src='/static_content/invisible.png' alt='invisible_to_force_width' style={{width: '100%', maxWidth: String(columnWidth) + 'px'}}/>
        </>
    )
}

//'100%'


function SectionDisplay ({textFirst, item, img, columnWidth, smallWindow}) {
    return (
        <>
            {textFirst ? <Text text={item.text} columnWidth={columnWidth}/> : null}
                                    
            {(item.img && item.img.length > 0) ?
                <ImageBox content={item}>
                    <img src={img} alt='event' style={{maxWidth: '100%', maxHeight: smallWindow ? '100px': null}}/> 
                </ImageBox>
            : null}
            {!textFirst ? <Text text={item.text} columnWidth={columnWidth}/> : null}
        </>
    )
}

function SectionBodyMasonry({content, smallWindow, section, windowWidth}) {
    const columnWidth = sizeMapNumbers[content[section].maxBoxWidth];
    const columnCount = Math.max(1,Math.trunc((windowWidth - 80) / columnWidth));
    const lastRowThreshold = content[section].sections.length - columnCount;

    return (
        <Body content={{smallWindow: smallWindow}}>
            
                <Masonry columnsCount={columnCount} gutter='30px' sequential={true}>
                    {content[section].sections.map((item, index) => {
                        return (
                            <Box id={item.title} key={'section_' + index} content={{...content.styles, ...content[section]}} style={{maxWidth: String(columnWidth) + 'px'}}>

                                <SectionDisplay textFirst={content[section].textFirst} item={item} img={content.imageMap[item.img]} columnWidth={columnWidth} smallWindow={smallWindow}/>

                                {(content.styles.mainBgColor === content.styles.textBoxBorderColor && content.styles.textBoxBgColor === content.styles.textBoxBorderColor && index < lastRowThreshold)  ? 
                                    <div style={{ padding: '5px', background: content.styles.textBoxBgColor}}>
                                        {content[section].textFirst ? <p>&nbsp;</p> : null}
                                        <hr color={content.styles.highlightColor}></hr>
                                    </div>
                                    : null}
                            </Box>
                        )
                    })}
                </Masonry>
            
        </Body>
    )
}

export const GridContainer = styled.div `
    display: grid;
    grid-template-columns: repeat( ${({content}) => content.columnCount}, minmax(100px, ${({content}) => content.maxWidth + 'px'}) ); 
    row-gap: 20px;
    column-gap: 20px;
`;

function SectionBodyGrid({content, smallWindow, section, windowWidth}) {
    const columnWidth = sizeMapNumbers[content[section].maxBoxWidth];
    const columnCount = Math.min(Math.max(1,Math.trunc((windowWidth - 80) / columnWidth)), content[section].sections.length);

    return (
        <Body content={{smallWindow: smallWindow}}>
                <GridContainer content={{columnCount: columnCount, maxWidth: columnWidth}}>
                    {content[section].sections.map((item, index) => {
                        return (
                            <Box id={item.title} key={'section_' + index} content={{...content.styles, ...content[section]}}>

                                <SectionDisplay textFirst={content[section].textFirst} item={item} img={content.imageMap[item.img]} columnWidth={columnWidth} smallWindow={smallWindow}/>
                                
                            </Box>
                        )
                    })}
                </GridContainer>
            
        </Body>
    )
}

export function SectionBody({content, smallWindow, section, windowWidth}) {
    // Decide if grid or masonary
    const textLengths = content[section].sections.map((item) => {
        return item.text.length;
    });
    const sum = textLengths.reduce((a, b) => a + b, 0);
    const avg = (sum / textLengths.length) || 0;
    const high = avg + (avg * gridThreshold);
    const low = avg - (avg * gridThreshold);
    let grid = true;

    textLengths.forEach((item) => {
        if (item < low || item > high) {
            grid = false
        }
    })

    return (
        <>
        {grid ? <SectionBodyGrid content={content} smallWindow={smallWindow} section={section} windowWidth={windowWidth} />
              : <SectionBodyMasonry content={content} smallWindow={smallWindow} section={section} windowWidth={windowWidth} />
        }
        </>
    )
}


const LinkContainer = styled.div `
    display: grid;
    grid-template-columns: 150px auto; 
    word-break: break-word;
    gap: 10px;
    padding:10px;
    @media (max-width: 400px) {
        grid-template-columns: auto; 
    }
`;

function LinkImage ({imageMap, item}) {
    if (item.img && item.img.length > 0) {
        return (
            <LinkImageBox content={{BgColor: null}}>
                <div><a href={item.url} target='_blank' rel='noreferrer'> <img src={imageMap[item.img]} alt='event' style={{maxHeight: '100px', maxWidth: '150px'}}/> </a></div>
            </LinkImageBox>
        )
    } else {
        return (
            <div></div>
        )
    }
}

function Links({content, smallWindow, section}) {
    const rowCount = content[section].sections.length;

    return (
        <Body content={{smallWindow: smallWindow}}>
            <Box content={{...content.styles, ...content[section]}}>
                <LinkContainer content={{rowCount: rowCount}}>
                    {content[section].sections.map((item, index) => {
                        return ([<LinkImage key={'Image' + String(index)} item={item} imageMap={content.imageMap}/>,
                                <TextBox key={'Text' + String(index)} >
                                    <a href={item.url} target='_blank' rel='noreferrer'><h4>{item.linkTitle}</h4></a>
                                    <SafeTextToHTML text={item.text} />
                                </TextBox>

                        ])
                    })}
                </LinkContainer>
            </Box>
        </Body>
    )
}

export default function Section({content, smallWindow, section, windowWidth}) {

    return (
        <Main content={content.styles}>
            <h1>&nbsp;{content[section].title}</h1>
            {(content[section].intro && content[section].intro.length > 0) 
                ?   <Body content={{smallWindow: smallWindow}}>
                        <Box content={{...content.styles, 'maxBoxWidth': 'Max'}}>
                            <TextBox>
                                <SafeTextToHTML text={content[section].intro} />
                            </TextBox>
                        </Box>
                    </Body>
                : null}
            { section === 'links' ?
                    <Links content={content} smallWindow={smallWindow} section={section} />
                : <SectionBody content={content} smallWindow={smallWindow} section={section} windowWidth={windowWidth} />
            }
        </Main>
    )        
}
